<app-form-generator
    *ngIf="formGenInput"
    (formGroupRef)="setSocialChannels($event)"
    [formGeneratorInput]="formGenInput"
></app-form-generator>
